import { toDetails } from "./http-error-details";
import { SentryError } from "./sentry-error";
import { ErrorContext } from "../../api/generated/backend";

export class FetchError extends SentryError {
  public constructor(context: ErrorContext) {
    super("FetchError", toDetails(context));
  }
}
